/* Amélie Bruxelles – taille obligatoire
   Aucune taille n'est présélectionnée visuellement ; l'ajout au panier est bloqué
   tant que la cliente n'a pas choisi sa taille. */
(function () {
  if (window.__abSizeRequired) return;
  window.__abSizeRequired = true;

  var chosen = false;
  var NAMES = /^(taille|pointure|size)$/i;

  var css = document.createElement('style');
  css.textContent =
    '.ab-size-unchosen .radio__button input:checked + label{background-color:transparent!important;color:#212121!important;}' +
    '.ab-size-error .radio__button label{border-color:#c0392b!important;}' +
    '.ab-size-msg{color:#c0392b;font-size:14px;margin:8px 0 0;font-weight:500;}';
  document.head.appendChild(css);

  function fieldsets() {
    return Array.prototype.filter.call(
      document.querySelectorAll('product-info .radio__fieldset'),
      function (f) {
        var n = f.querySelector('.radio__legend__option-name');
        return n && NAMES.test(n.textContent.trim()) &&
          f.querySelectorAll('input[type="radio"]').length > 1;
      }
    );
  }

  function apply() {
    if (chosen) return;
    fieldsets().forEach(function (f) {
      f.classList.add('ab-size-unchosen');
      var v = f.querySelector('.radio__legend__value');
      if (v && v.textContent !== '') v.textContent = '';
    });
  }

  function choose(f, value) {
    chosen = true;
    document.querySelectorAll('.ab-size-unchosen, .ab-size-error').forEach(function (x) {
      x.classList.remove('ab-size-unchosen', 'ab-size-error');
    });
    document.querySelectorAll('.ab-size-msg').forEach(function (m) { m.remove(); });
    var v = f && f.querySelector('.radio__legend__value');
    if (v && value) v.textContent = value;
  }

  function showError() {
    var f = fieldsets()[0];
    if (!f) return;
    f.classList.add('ab-size-error');
    if (!f.querySelector('.ab-size-msg')) {
      var m = document.createElement('p');
      m.className = 'ab-size-msg';
      m.setAttribute('role', 'alert');
      m.textContent = 'Veuillez choisir votre taille.';
      f.appendChild(m);
    }
    f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function needsSize() {
    return !chosen && fieldsets().length > 0;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var f = t.closest('.ab-size-unchosen');
    var opt = t.closest('.radio__button');
    if (f && opt) {
      var inp = opt.querySelector('input');
      choose(f, inp && inp.value);
      return;
    }
    var btn = t.closest('product-info [name="add"], product-info [data-add-to-cart]');
    if (btn && needsSize()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    var f = t && t.closest && t.closest('.ab-size-unchosen');
    if (f) choose(f, t.value);
  }, true);

  document.addEventListener('submit', function (e) {
    var fm = e.target;
    if (fm && fm.closest && fm.closest('product-info') && needsSize()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);

  var scheduled = false;
  new MutationObserver(function () {
    if (chosen || scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
